import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class RepresentativeMonthlyShiftActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Hr/BranchPeriodShift/BranchPeriodShiftBrowser")
	}

	render() {
		return (
			<Activity 
				name="RepresentativeMonthlyShift"
				RenderedComponent={this.RenderedComponent}
				context="RepresentativeMonthlyShift"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(RepresentativeMonthlyShiftActivity)
